import { css, keyframes } from 'styled-components';

const loadingKeyframes = keyframes`
  100% {
    transform: translateX(100%);
  }
`;

const loadingKeyframesRules = css`
  ${loadingKeyframes} 1.5s infinite;
`;

const blockedStyles = ({ isBlocked }) =>
  isBlocked &&
  css`
    opacity: 0.5;
  `;

const notBlockedStyles = ({ isBlocked }) => {
  return (
    !isBlocked &&
    css`
      &:hover,
      &.isHovered {
        .on_hover {
          display: block;
        }
        .actions_button {
          display: block;
        }
        .cell {
          background-color: var(--grey100);
          &__dark {
            background-color: var(--grey200);
          }
        }
      }
    `
  );
};

const listItemStyles = css`
  background-color: white;
  height: 36px;
  margin-bottom: 1px;
  display: flex;
  align-items: stretch;
  color: var(--grey700);
  text-decoration: none;

  ${blockedStyles}
  ${notBlockedStyles}

  .cell {
    padding: 0 8px;
    white-space: nowrap;
    display: flex;
    align-items: center;

    &__nowrap {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    &__bold {
      font-weight: bold;
    }
    &__center {
      justify-content: center;
    }
    &__right {
      justify-content: flex-end;
    }
    &__flex {
      display: flex;
    }
    &__dark {
      background-color: var(--grey100);
    }
    &__grow {
      flex: 1;
    }
    &__hidden_overflow {
      overflow: hidden;
    }
    &__nopadding {
      padding: 0;
    }
    &__line {
      line-height: 0;
    }

    &__pending-appointment {
      color: var(--accent900);
    }
    &__appointment-ok {
      color: var(--success900);
    }
  }

  .bad-value {
    color: var(--error500);
  }
  .good-value {
    color: var(--success700);
  }

  .cell__shipper {
    &__name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &__more {
      color: var(--grey500);
      display: inline-block;
      margin-left: 4px;
    }
    &__tags {
      display: flex;
      margin-left: 8px;
      span + span {
        margin-left: 4px;
      }
    }
  }

  .cell__stop {
    line-height: normal;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;

    .stop__nowrap {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
    }
    .stop__time {
      color: var(--grey900);
    }
    .stop__date {
      margin-right: 4px;
      display: inline-block;
    }
    .stop__diff {
      background-color: var(--grey100);
      color: var(--error500);
      border-radius: 4px;
      border-radius: 4px;
      height: 16px;
      display: inline-flex;
      align-items: center;
      padding: 0 2px;
      margin-left: 6px;
    }

    .stop__editable {
      display: flex;
      width: 100%;
    }

    .stop__editable_edit_container.visible {
      visibility: visible;
    }

    .stop__editable:hover {
      .stop__editable_edit_container {
        visibility: visible;
      }
    }

    .stop__editable_times_container {
      overflow: hidden;
      flex: 1;
      margin-right: 8px;
    }

    .stop__editable_edit_container {
      visibility: hidden;
    }
  }

  .stop__duplicate_button {
    visibility: hidden;
  }

  &:hover {
    .stop__duplicate_button {
      visibility: visible;
    }
  }

  .tooltip-container {
    display: flex;
    align-items: stretch;
  }

  .pointer {
    cursor: pointer;
  }

  &__loading {
    position: relative;
    opacity: 0.5;
    &:after {
      display: block;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      transform: translateX(-100%);
      background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.1), transparent);
      animation: ${loadingKeyframesRules};
    }
  }

  .on_hover {
    display: none;
  }

  .actions_button {
    display: none;
    height: 28px;
    color: var(--primary900);
    border: 1px solid var(--primary300);
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    padding: 0 8px;
    outline: none;
    background: #fff;
    overflow: hidden;

    &__force_show {
      & {
        display: block;
      }
    }
  }

  .reason {
    margin-right: 8px;
  }

  .cell__indicator {
    height: 37px;
    background-color: var(--grey200);
    display: flex;
    align-items: center;
    justify-content: center;
    &__locked {
      background-color: var(--grey900);
    }
    .lock-icon {
      width: 24px;
      height: 24px;
      border-radius: 24px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        fill: var(--grey00);
        width: 16px;
      }
    }

    .upgrade-icon {
      width: 24px;
      height: 24px;
      border-radius: 24px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        fill: var(--deep-purple500);
        width: 16px;
      }
    }
  }

  .upgrade-suggestion {
    svg {
      fill: var(--deep-purple500);
      width: 16px;
    }
  }
  .mr-container {
    position: relative;
    width: 100%;
    text-align: center;
  }
  .mr-number-stops {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 5px;
    bottom: 0px;
  }
  .mr-icon {
    margin-top: 12px;
  }

  .journey-upgrade {
    svg {
      fill: var(--primary300);
      width: 16px;
    }
  }

  .cell__cost {
    font-weight: bold;
  }

  .cell__cost_adjustment {
    display: flex;
    font-weight: bold;
    .field {
      width: 70px;
      margin-right: 8px;
      input {
        padding-right: 15px;
      }
    }
    .value {
      margin-left: 0.8rem;
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;

      &.positive {
        border-bottom: 4px solid var(--error500);
      }

      &.negative {
        border-top: 4px solid var(--primary300);
      }
    }
  }
`;

export default listItemStyles;
